import { render, staticRenderFns } from "./add_new.vue?vue&type=template&id=13f6cffc&scoped=true"
import script from "./add_new.vue?vue&type=script&lang=js"
export * from "./add_new.vue?vue&type=script&lang=js"
import style0 from "./add_new.vue?vue&type=style&index=0&id=13f6cffc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13f6cffc",
  null
  
)

export default component.exports